
@switch (displayType) {
  @case ('sidebar') {
    <app-sidebar-display
      [infographic]="infographic | async"
    ></app-sidebar-display>
  }
  @case ('mouse-popup') {
    <app-mouse-popup-display
      [infographic]="infographic | async"
    ></app-mouse-popup-display>
  }
  @case ('modal') {
    <app-modal-display [infographic]="infographic | async"></app-modal-display>
  }
  @default {
    <p>invalid display type</p>
  }
}
